
import { Controller, Shark } from "shark-mvc";

class SoundManager extends Controller {
	static TYPE_CUSTOM = "custom";
	static TYPE_SAW_TOOTH = "sawtooth";
	static TYPE_SINE = "sine";
	static TYPE_SQUARE = "square";
	static TYPE_TRIANGLE = "triangle";

	audioCtx;

	constructor () {
		super("soundManager");
		
		//if you have another AudioContext class use that one, as some browsers have a limit
		this.audioCtx = new (window.AudioContext || window.webkitAudioContext || window.audioContext);
	}
	//All arguments are optional:
	//duration of the tone in milliseconds. Default is 500
	//frequency of the tone in hertz. default is 440
	//volume of the tone. Default is 1, off is 0.
	//type of tone. Possible values are sine, square, sawtooth, triangle, and custom. Default is sine.
	//callback to use on end of tone
	beep (duration = 500, frequency = 440, volume = 50, type = SoundManager.TYPE_SINE, callback) {
		return new Promise(resolve => {
			const oscillator = this.audioCtx.createOscillator();
			const gainNode = this.audioCtx.createGain();
			
			oscillator.connect(gainNode);
			gainNode.connect(this.audioCtx.destination);
			
			gainNode.gain.value = volume / 10;
			oscillator.frequency.value = frequency;
			oscillator.type = type;
			if (callback){oscillator.onended = callback;}
			
			oscillator.start(this.audioCtx.currentTime);

			setTimeout(() => {
				oscillator.stop();
				setTimeout(() => {
					resolve(true);
				}, 20);
			}, duration);
		});
	}

	signal (duration, soundFrequency) {
		const signalPromises = [];

		const enableSounds = Shark.$store.appSettings.enableSounds;
		const enableVibration = Shark.$store.appSettings.enableVibration;

		if (enableSounds) {
			signalPromises.push(this.beep(duration, soundFrequency));
		}

		if (enableVibration) {
			signalPromises.push(this.vibrate(duration * 5));
		}

		return Promise.all(signalPromises)
		.then(results => {
			return {
				sound: enableSounds ? results[0] : null,
				vibration: enableVibration ? (enableSounds ? results[1] : results[0]) : null,
			};
		});
	}

	vibrate (duration) {
		return new Promise(resolve => {
			navigator.vibrate(duration);

			setTimeout(() => {
				resolve(true);
			}, duration + 20);
		});
	}
}

const soundManager = new SoundManager();

Shark.registerController(soundManager);

export default soundManager;
